<template>
  <div class="view-tasklists account-lookup">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <div class="content-wrapper">
      <div class="container-wrapper center" >

        <div class="col-12 override-padding">
          <div class="col-6 override-padding float-left">
          <h3 class="d-inline heading">
            Activity Report
          </h3>
          </div>
          <div class="col-6 override-padding float-right text-align-right">
            <div class="col-4 float-left padding-lr-5" style="margin-top: 2px;">
              <date-picker
                v-model="search_date"
                placeholder="Date"
                format="MM/DD/YYYY"
                v-bind:clearable="false"
                :disabled-date="disabledAfterToday"
                input-class="col-md-12 input-height-25 padding-lr-5" @change="dateClickEvent()" 
                >
                <template v-slot:icon-calendar>
                  <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                </template>
              </date-picker>
            </div>
            <div class="col-8 float-right padding-lr-5" style="margin-top: 2px;">
              <router-link to="/report-dashboard">
                <button class="btn btn-red btn-md input-height-15 report-dashboard-link"><i class="fa fa-chevron-left" aria-hidden="true" style="padding-right: 10px;"></i> Back to Reporting Dashboard</button>
              </router-link>
            </div>
            <div style="clear: both"></div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="heading-seperator"></div>
        <div style="clear: both; float: none;" class="col-12 margin-bottom-10"></div>

        <div v-if="iframe_report == true" class="col-12" >

          <iframe class="col-12" style="height: 1024px; border: 0;" id="pdf-frame"></iframe>
        </div>
        <div class="" v-if="display_report == true">
          <div class="row account_view_list_heading_row col-6 float-left account-lookup-view-list">
            <table border="1" cellpadding="5" class="view-lists col-12" style="border-color:#b6b6b6">
              <tr>
                <th class="field_title">Managers</th>
                <th class="field_title" style="padding-left: 5px;">24 Hrs</th>
                <th class="field_title" style="padding-left: 5px;">Week</th>
                <th class="field_title" style="padding-left: 5px;">MTD</th>
                <th class="field_title" style="padding-left: 5px;">YTD</th>
              </tr>
              <tr class="" v-for="(item, mindex) in managerLists" :key="mindex">
                <td>{{ item.information }}</td>
                <td class="text-align-center blue-color" >{{ item.day }}</td>
                <td class="text-align-center blue-color" >{{ item.week }}</td>
                <td class="text-align-center blue-color" >{{ item.mtd }}</td>
                <td class="text-align-center blue-color" >{{ item.ytd }}</td>
              </tr>
            </table>
          </div>

          <div class="row account_view_list_heading_row col-6 float-left account-lookup-view-list" style="padding-left: 15px !important;">
            <table border="1" cellpadding="5" class="view-lists col-12" style="border-color:#b6b6b6">
              <tr>
                <th class="field_title">Mentors</th>
                <th class="field_title" style="padding-left: 5px;">24 Hrs</th>
                <th class="field_title" style="padding-left: 5px;">Week</th>
                <th class="field_title" style="padding-left: 5px;">MTD</th>
                <th class="field_title" style="padding-left: 5px;">YTD</th>
              </tr>
              <tr class="" v-for="(item, mrindex) in mentorLists" :key="mrindex">
                <td>{{ item.information }}</td>
                <td class="text-align-center blue-color" >{{ item.day }}</td>
                <td class="text-align-center blue-color" >{{ item.week }}</td>
                <td class="text-align-center blue-color" >{{ item.mtd }}</td>
                <td class="text-align-center blue-color" >{{ item.ytd }}</td>
              </tr>
            </table>
          </div>
          <div style="clear: both; margin-bottom: 20px;"></div>


          <div class="row account_view_list_heading_row col-6 float-left account-lookup-view-list" >
            <table border="1" cellpadding="5" class="view-lists col-12" style="border-color:#b6b6b6">
              <tr>
                <th class="field_title">Enterprise</th>
                <th class="field_title" style="padding-left: 5px;">24 Hrs</th>
                <th class="field_title" style="padding-left: 5px;">Week</th>
                <th class="field_title" style="padding-left: 5px;">MTD</th>
                <th class="field_title" style="padding-left: 5px;">YTD</th>
              </tr>
              <tr class="" v-for="(item, eindex) in enterpriseLists" :key="eindex">
                <td>{{ item.information }}</td>
                <td class="text-align-center blue-color" >{{ item.day }}</td>
                <td class="text-align-center blue-color" >{{ item.week }}</td>
                <td class="text-align-center blue-color" >{{ item.mtd }}</td>
                <td class="text-align-center blue-color" >{{ item.ytd }}</td>
              </tr>
            </table>
          </div>

          <div class="row account_view_list_heading_row col-6 float-left account-lookup-view-list" style="padding-left: 15px !important;">
            <table border="1" cellpadding="5" class="view-lists col-12" style="border-color:#b6b6b6">
              <tr>
                <th class="field_title">Mentees/Apprentices</th>
                <th class="field_title" style="padding-left: 5px;">24 Hrs</th>
                <th class="field_title" style="padding-left: 5px;">Week</th>
                <th class="field_title" style="padding-left: 5px;">MTD</th>
                <th class="field_title" style="padding-left: 5px;">YTD</th>
              </tr>
              <tr class="" v-for="(item, meindex) in menteeLists" :key="meindex">
                <td>{{ item.information }}</td>
                <td class="text-align-center blue-color" >{{ item.day }}</td>
                <td class="text-align-center blue-color" >{{ item.week }}</td>
                <td class="text-align-center blue-color" >{{ item.mtd }}</td>
                <td class="text-align-center blue-color" >{{ item.ytd }}</td>
              </tr>
            </table>
          </div>

          <div style="clear: both; margin-bottom: 40px;"></div>



        </div>








      </div>
      </div>


   </div>


  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../../shared/user_menu.vue';
import MasteradminSidebarMenu from '../../shared/masteradmin_sidebar_menu.vue';
import axios from 'axios';
import router from '../../../router/index.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  data() {
    return {
      apiUrl: '',
      masterAdmin: false,
      managerLists: [],
      mentorLists: [],
      menteeLists: [],
      enterpriseLists: [],
      search_date: today,
      display_report: true,
      iframe_report: false,
      pdf_file_name: '',
    }
  },

  components: {
    UserMenu,
    MasteradminSidebarMenu,
    DatePicker,
  },
  methods: {
    dateClickEvent: function() {
      const dateStr = moment(this.search_date).format('YYYY-MM-DD HH:mm:ss');
      const todatStr = moment(today).format('YYYY-MM-DD HH:mm:ss');

      if(dateStr == todatStr) {
        this.iframe_report = false;
        this.getActivityReportToday();
      }
      else {
        this.display_report = false;
        this.managerLists = [];
        this.mentorLists = [];
        this.menteeLists = [];
        this.enterpriseLists = [];
        this.iframe_report = true;
        this.getPDFReport();
      }
    },
    getPDFReport: function() {
      const datePDFStr = moment(this.search_date).format('MM-DD-YYYY');
      this.pdf_file_name = 'activity-report-' + datePDFStr + '.pdf';
      fetch(this.apiUrl + '/custom/activity-report/pdf-view/' + this.pdf_file_name).then(function(response) {
          return response.blob();
      }).then(function(myBlob) {
          var objectURL = URL.createObjectURL(myBlob);
          document.querySelector('#pdf-frame').src = '';
          document.querySelector('#pdf-frame').src = objectURL;
          objectURL = URL.revokeObjectURL(myBlob);
      }).then(
          function() {
          });
        return false;
    },

    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    getActivityReportToday: function() {
      axios.get('/desktop/activity-report-today', {

      })
      .then(response =>  {
        this.managerLists = response.data.manager;
        this.mentorLists = response.data.mentor;
        this.menteeLists = response.data.mentee;
        this.enterpriseLists = response.data.enterprise;
        this.display_report = true;
      })
      .catch(function(error) {

      });

    },
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }

    this.getActivityReportToday();

  },
}
</script>

<style scoped>
  label {
    padding-top: 8px;
  }
  .border-content {
    border: 1px solid #CCC;
    padding-top: 10px;
    border-top: 0;
  }
  .display_column_heading {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 20px;
    margin-top: 2px;
    color: #FFF;
  }
  .collapse-wrapper {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 10px;
    margin-top: 2px;
  }
  .collapse-wrapper a, .collapse-wrapper a:hover{ 
    color: #FFF;
    text-decoration: none;
    padding-top: 5px;
    display: inherit;
  }
  .collapse-wrapper i {
    float: right;
    font-size: 18px;
    font-weight: bold;
    padding-top: 0px;
    color: #FFF;
  }

</style>
<style scoped>
@import '../../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}
.account_view_list_heading_row {
  background: none;
  padding: 3px 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
tr th {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
tr td {
  color: #212529;
}
.account-lookup-view-list .field_title {
    width: auto;
    border-right: 0px solid #b6b6b6;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
}
.view-lists {
  width: 100%;
}
.custom-select {
  height: 38px;
}
.report-dashboard-link {
  text-transform: uppercase;
}
.report-dashboard-link .fa-chevron-left {
  font-size: 13px !important;
}
    .blue-color {
      color: #00ACEE;
    }
</style>




// WEBPACK FOOTER //
// src/components/admin/reports/activity_report.vue